"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlaceholder = isPlaceholder;
exports.compileChatMessages = compileChatMessages;
exports.compileChatMessagesWithIds = compileChatMessagesWithIds;
exports.extractPlaceholderNames = extractPlaceholderNames;
const uuid_1 = require("uuid");
const types_1 = require("./types");
function isPlaceholder(message) {
    return "type" in message && message.type === types_1.ChatMessageType.Placeholder;
}
function replaceTextVariables(content, textVariables) {
    let result = content;
    for (const [varName, varValue] of Object.entries(textVariables)) {
        // Create regex that handles optional whitespace around variable name
        const variablePattern = new RegExp(`{{\\s*${varName}\\s*}}`, "g");
        result = result.replace(variablePattern, varValue);
    }
    return result;
}
function expandPlaceholder(placeholder, placeholderValues) {
    const replacementMessages = placeholderValues[placeholder.name];
    if (!replacementMessages) {
        throw new Error(`Missing value for message placeholder: ${placeholder.name}`);
    }
    if (!Array.isArray(replacementMessages)) {
        throw new Error(`Placeholder value for '${placeholder.name}' must be an array of messages`);
    }
    // Allow arbitrary objects - just pass them through as ChatMessage
    // Users might want to use ChatML with placeholders for any message structure
    return replacementMessages.map((replacementMsg) => {
        if (typeof replacementMsg === "object" && replacementMsg !== null) {
            return replacementMsg;
        }
        throw new Error(`Invalid message in placeholder '${placeholder.name}': expected object but got ${typeof replacementMsg}`);
    });
}
function compileChatMessages(messages, placeholderValues, textVariables) {
    const expandedMessages = messages.flatMap((message) => isPlaceholder(message)
        ? expandPlaceholder(message, placeholderValues)
        : [message]);
    // substitute text variables
    if (!textVariables || Object.keys(textVariables).length === 0) {
        return expandedMessages;
    }
    return expandedMessages.map((message) => {
        if (!message.content || typeof message.content !== "string") {
            return message;
        }
        return {
            ...message,
            content: replaceTextVariables(message.content, textVariables),
        };
    });
}
function compileChatMessagesWithIds(messages, placeholderValues, textVariables) {
    // TODO: check, is it even important to retain the IDs?
    const expandedMessages = messages.flatMap((message) => {
        if (isPlaceholder(message)) {
            const expandedMsgs = expandPlaceholder(message, placeholderValues);
            return expandedMsgs.map((msg) => ({ ...msg, id: (0, uuid_1.v4)() }));
        }
        // Preserve message IDs for already non-placeholder messages
        return [message];
    });
    // substitute text variables
    if (!textVariables || Object.keys(textVariables).length === 0) {
        return expandedMessages;
    }
    return expandedMessages.map((message) => {
        if (!message.content || typeof message.content !== "string") {
            return message;
        }
        return {
            ...message,
            content: replaceTextVariables(message.content, textVariables),
        };
    });
}
function extractPlaceholderNames(messages) {
    return messages
        .filter((msg) => "type" in msg && msg.type === types_1.ChatMessageType.Placeholder)
        .map((msg) => msg.name);
}
